import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Reset Password")
], -1)
const _hoisted_3 = { class: "modal-body" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Enter a new password below", -1)
const _hoisted_5 = {
  key: 0,
  class: "alert alert-danger mb-3"
}
const _hoisted_6 = {
  key: 1,
  class: "alert alert-info mb-3"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "input-group mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "input-group-text",
  id: "basic-addon1"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-lock" })
], -1)
const _hoisted_10 = { class: "input-group mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  class: "input-group-text",
  id: "basic-addon1"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-lock" })
], -1)
const _hoisted_12 = { class: "modal-footer" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Back to login")
const _hoisted_14 = {
  key: 0,
  type: "submit",
  class: "btn btn-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.resetPassword()), ["prevent","stop"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.error), 1))
          : _createCommentVNode("", true),
        (_ctx.requested)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, " A password recover request has been made. If the entered emailaddress exists in our database you will receive an email with instructions to create a new password. "))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  class: "form-control",
                  placeholder: "New password",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.password]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  class: "form-control",
                  placeholder: "New password",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password_verify) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.password_verify]
                ])
              ])
            ]))
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_router_link, { to: "/login" }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }),
        (!_ctx.requested)
          ? (_openBlock(), _createElementBlock("button", _hoisted_14, "Reset password"))
          : _createCommentVNode("", true)
      ])
    ], 32)
  ]))
}